import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Award, Printer } from "lucide-react";
import { api, formatDate, mediaUrl } from "@/lib/api";

export default function CertificatePage() {
  const { code } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api(`/public/certificate/${code}`).then(setC).catch(e => setErr(e.message)); }, [code]);

  if (err) return <main className="login-page"><div className="login-panel"><h1>Certificate unavailable</h1><p data-testid="certificate-error">{err}</p></div></main>;
  if (!c) return <div className="loading" data-testid="certificate-loading">Preparing certificate…</div>;

  return (
    <main className="cert-page">
      <button className="button button-gold no-print" onClick={() => window.print()} data-testid="certificate-print"><Printer size={15} /> Print / Save as PDF</button>
      <article className="certificate" data-testid="certificate">
        <div className="cert-border">
          <header>
            {c.logo ? <img src={mediaUrl(c.logo)} alt="" className="cert-logo" /> : <span className="brand-mark">D</span>}
            <div><b>{c.short_name || "DCEA"} Hubli–Dharwad</b><small>{c.association}</small></div>
          </header>
          <span className="eyebrow">Certificate of participation</span>
          <h1>This is to certify that</h1>
          <p className="cert-name" data-testid="certificate-name">{c.name}</p>
          <p className="cert-text">participated in <strong data-testid="certificate-event">{c.event?.title}</strong> held on {formatDate(c.event?.date)}{c.event?.venue ? ` at ${c.event.venue}` : ""}, organised by the {c.association}.</p>
          <footer>
            <div className="cert-sign"><span /><b>{c.signatory?.name || "President"}</b><small>{c.signatory?.position || "President"}, {c.short_name || "DCEA"}</small></div>
            <Award size={46} className="cert-seal" />
            <div className="cert-sign"><span /><b>Ref {c.registration_id}</b><small>Verified attendance · {formatDate(c.attended_at)}</small></div>
          </footer>
        </div>
      </article>
    </main>
  );
}
